import React from "react"
import WizardStep from "../WizardStep"
import { WizardState } from "../use-wizard"
import { useTranslation } from "react-i18next"
import { useDeliveryCodeQuery } from "./queries.generated"
import Loading from "../../../components/Loading"
import LockerAction from "../../../components/LockerAction"
import { ErrorMessage, TouchButton } from "pusatec-react-native"
import { useMyLockersystemPerm } from "../../../components/featureParameters"

interface Props {
	wizardState: WizardState
	deliveryId: string
	lockersystemId?: string
	onCreateIssue: () => void
	onCancel(): void
	onComplete(): void
	onShareCode(): void
}

export default function PlaceDeliveryStep(props: Props) {
	const {
		wizardState,
		deliveryId,
		onCreateIssue,
		onCancel,
		onComplete,
		onShareCode,
		lockersystemId,
	} = props

	const { t } = useTranslation()

	const { data, loading, error } = useDeliveryCodeQuery({
		variables: { deliveryId },
		pollInterval: 2000,
	})
	const delivery = data?.delivery
	const perm = lockersystemId ? useMyLockersystemPerm(lockersystemId) : null
	const isAdmin = !!perm?.isAdmin && !perm?.accessDenied

	if (loading) return <Loading />
	if (error || !delivery) return <ErrorMessage extra={error} />

	return (
		<WizardStep
			title={t("")}
			wizardState={wizardState}
			scroll
		>
			<div style={{
				fontFamily: "Nunito, Mada-Regular, sans-serif",
				fontSize: 25,
				textAlign: "center"
			}}>
				{t("Place delivery into locker")}
			</div>
			<LockerAction
				code={delivery.deliveryCode!}
				useCodeBefore={delivery.useDeliveryCodeBefore}
				codeUsedAt={delivery.deliveryCodeUsedAt}
				onReportIssue={onCreateIssue}
				onComplete={onComplete}
				onCancel={onCancel}
			>
				{isAdmin && (
					<TouchButton
						type="secondary"
						text={t("Send code")}
						onPress={onShareCode}
					/>
				)}
			</LockerAction>
		</WizardStep>
	)
}
